export function shouldUseUkCdnBetslip(isUkStyle: boolean, repub: string | undefined | null): boolean {
  if (!isUkStyle || !repub) return false;
  return repub.toUpperCase() === 'OC';
}
